import { SCREEN_IDS } from '@app/consts/common_consts';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProjectSelectionState {
  visible: boolean;
  projectId: number | null;
  fromScreenRouter: SCREEN_IDS | null;
}

type SetVisibleProjectSelectionPayload = {
  visible: boolean;
  fromScreenRouter?: SCREEN_IDS | null;
};

const initialState: ProjectSelectionState = {
  visible: false,
  projectId: null,
  fromScreenRouter: null,
};

const projectSelectionSlice = createSlice({
  name: 'projectSelection',
  initialState,
  reducers: {
    setVisibleProjectSelection: (state, action: PayloadAction<SetVisibleProjectSelectionPayload>) => {
      state.visible = action.payload.visible;
      state.fromScreenRouter = action.payload.fromScreenRouter ?? null;
    },
    setProjectIdSelection: (state, action: PayloadAction<number | null>) => {
      state.projectId = action.payload;
    },
  },
});

export const { setVisibleProjectSelection, setProjectIdSelection } = projectSelectionSlice.actions;
export default projectSelectionSlice.reducer;
